import { Axios } from "index";

export const plywoodItemSrnoDropdownApi =
  "/plywood-inventory/item-srno-dropdown";
export const plywoodInwardSrnoDropdownApi =
  "/plywood-inventory/inward-srno-dropdown";

//Approval
export const fetchPlywoodApprovalApi = `/approval/plywood-approval-invoice-listing`;
export const fetchPlywoodItemsApprovalApi = function (id, invoice_id) {
  return `/approval/plywood-approval-item-listing-by-invoice/${id}/${invoice_id}`;
};
export const plywoodApproveInvoiceApi = function (id, invoice_id) {
  return `/approval/plywood-approve_invoice_details/${id}/${invoice_id}`;
};
export const plywoodRejectInvoiceApi = function (id, invoice_id) {
  return `/approval/plywood-reject_invoice_details/${id}/${invoice_id}`;
};
export const fetchPalletNoDropdown = async (id) => {
  const res = await Axios.get(`/plywood-inventory/pallet-no-dropdown/${id}`);
  return res;
};
export const fetchPalletNoById = async (id) => {
  const res = await Axios.get(`/plywood-inventory/list-plywood-details/${id}`);
  return res;
};

export const addRawOrderPlywood = async (data) => {
  const res = await Axios.post(
    "/order/issue-raw-plywood-order/issue-order",
    data
  );
  return res;
};
export const revertRawOrderPlywood = async (id) => {
  const res = await Axios.post(`/order/revert-order/${id}`);
  return res;
};
